import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { mergeMap, Observable } from 'rxjs';
import { DeviceManufacturer } from '../interfaces/allowed-device';
import { UserLevel } from '../models/user-level';

@Injectable({
  providedIn: 'root',
})
export class DeviceManufacturerRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(deviceManufacturer: DeviceManufacturer): Observable<void> {
    return this.utils.routeBasedApiUrl('/deviceManufacturers', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.post<void>(url, deviceManufacturer)),
      wrapError('device-manufacturer-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceManufacturers/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('device-manufacturer-repository:delete')
    );
  }

  list(): Observable<DeviceManufacturer[]> {
    return this.utils.routeBasedApiUrl('/deviceManufacturers', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.get<DeviceManufacturer[]>(url)),
      wrapError('device-manufacturer-repository:list')
    );
  }

  listForEnterprise(): Observable<DeviceManufacturer[]> {
    return this.utils.routeBasedApiUrl('/deviceManufacturers', UserLevel.EnterpriseAdmin).pipe(
      mergeMap((url) => this.http.get<DeviceManufacturer[]>(url)),
      wrapError('device-manufacturer-repository:list')
    );
  }

  update(id: number, deviceManufacturer: DeviceManufacturer): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceManufacturers/${id}`, UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.put<void>(url, deviceManufacturer)),
      wrapError('device-manufacturer-repository:update')
    );
  }
}
